import { useEffect } from "react";
import { Grid, Typography, Dialog, DialogTitle, DialogActions, DialogContent, Button, IconButton, Divider } from "@mui/material";
import { closelightbox } from "../../../util/Functions";
import { ModalStyle } from "../../../util/Styles";
import { useValidateClabe } from "./hooks/useValidateClabe";
import { Close } from "@mui/icons-material";
import { AttachFile } from "@mui/icons-material";

const ValidateClabe = ({ open, changeAlert, changeLoader, setWidgets, updateNext }) => {
    const { list, isValidForm, zPos, onSelectFile, onConfirm, deleteFromList } = useValidateClabe(open, changeAlert, changeLoader, setWidgets, updateNext);
    
    const midIndex = Math.ceil(list.length / 2);
    const leftColumn = list.slice(0, midIndex);
    const rightColumn = list.slice(midIndex);

    const addFile = () => {
        document.getElementById("file").click();
    };

    useEffect(() => {
        init();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const init = async () => {
        await document
        if(document.getElementById("file")){
            document.getElementById("file").click();
        }
    };

    return (
        <Dialog open={true} fullWidth sx={{ zIndex: zPos, filter: zPos !== 45 ? "blur(2px)" : "none" }}>
            <ModalStyle property={String(isValidForm)}>
                <DialogTitle style={{ marginBottom: "0" }}>
                    <span>
                        Consulta de CLABES
                        <p id="subtitle_2"> Validación masiva de CLABES Interbancarias</p>
                    </span>
                    <IconButton onClick={addFile.bind(this, "")} id="headButton" sx={{ paddingTop: "0 !important" }}>
                        <AttachFile titleAccess="Agregar desde csv" />
                        <input id="file" type="file" accept="text/csv" style={{ display: "none" }} onChange={onSelectFile.bind(this)}/>
                    </IconButton>
                </DialogTitle>

                <DialogContent sx={{ paddingTop: "5px !important" }}>
                    <div id="subtitle_2">Cantidad de registros: {list.length}</div>
					<Divider sx={{mt: -2, mb: 1}} />

                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                        {leftColumn.map((item, index) => (
                            <Typography key={index} variant="body1" >
                            <Close titleAccess={`Eliminar de \nla lista`} onClick={() => deleteFromList(item)} cursor={"pointer"} sx={{pr: 1, verticalAlign: "bottom"}}/>
                            {item}
                            </Typography>
                        ))}
                        </Grid>
                        <Grid item xs={6}>
                        {rightColumn.map((item, index) => (
                            <Typography key={index} variant="body1">
                            <Close titleAccess={`Eliminar de \nla lista`} onClick={() => deleteFromList(item)} cursor={"pointer"} sx={{pr: 1, verticalAlign: "bottom"}}/>
                            
                            {item}
                            </Typography>
                        ))}
                        </Grid>
                    </Grid>
                </DialogContent>

                <DialogActions>
                    <Button onClick={closelightbox} variant="outlined" id='buttonCancel'>
                        Cancelar
                    </Button>
                    <Button onClick={onConfirm.bind(this)} disabled={isValidForm} variant="contained">
                        Consultar
                    </Button>
                </DialogActions>
            </ModalStyle>
        </Dialog>
    );
};

export default ValidateClabe;
